import { render } from "./BeneficiaryCommitmentModal.vue?vue&type=template&id=60646177"
import script from "./BeneficiaryCommitmentModal.vue?vue&type=script&lang=js"
export * from "./BeneficiaryCommitmentModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__